type IconProps = React.ComponentProps<'svg'>

export function ActivityIcon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(1.25, 2.25)">
        <path
          d="M7.75 0c0.32282 0 0.60983 0.20644 0.71191 0.5127l5.28809 15.86425 2.28809-6.86425c0.10208-0.30626 0.38909-0.5127 0.71191-0.5127l4 0c0.41421 0 0.75 0.33579 0.75 0.75 0 0.41421-0.33579 0.75-0.75 0.75l-3.45898 0-2.82911 8.4873c-0.10209 0.30626-0.38909 0.5127-0.71191 0.5127-0.32282 0-0.60983-0.20644-0.71191-0.5127l-5.28809-15.86425-2.28809 6.86425c-0.10209 0.30626-0.38909 0.5127-0.71191 0.5127l-4 0c-0.41421 0-0.75-0.33579-0.75-0.75 0-0.41421 0.33579-0.75 0.75-0.75l3.45898 0 2.82911-8.4873 0.04687-0.10938c0.12759-0.24495 0.3824-0.40332 0.66504-0.40332z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
